<template>
    <div class="top" v-bind:style="topStyle">
        <div class="branding">
            <img :src="imgLink" :alt="imgAlt" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Survey-Header',
        props: [
            'title',
            'titleColor',
            'titleFontSize',
            'description',
            'descriptionColor',
            'descriptionFontSize',
            'highlightColor',
            'imgLink'
        ],

       computed: {
            topStyle() {
                return {
                    'border-color': this.highlightColor
                }
            }
        },
        data() {
            return {
                imgAlt: 'GuestFlip'
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .branding {
        padding: 20px 0;
        text-align: center;
    }
    .branding img {
        max-width: 100%;
    }
    .title {
        text-align: center;
        margin: 0 0 10px 0;
        font-size: 24px;
        font-weight: 700;
    }
    .description {
        text-align: center;
     }
    .top {
        margin-bottom: 30px;
        background: #fff;
        border-bottom: solid 2px;
    }
</style>



// WEBPACK FOOTER //
// node_modules/survey-fields/src/Wrappers/SurveyHeader.vue